export enum ActionTypes {
  ShowLoading = 'loading/show',
  HideLoading = 'loading/hide',
}

export interface LoadingAction {
  type: ActionTypes;
  loadingText?: string;
}

export const showLoading = (loadingText?: string) => {
  return {
    type: ActionTypes.ShowLoading,
    loadingText,
  } as LoadingAction;
};

export const hideLoading = () => {
  return {
    type: ActionTypes.HideLoading,
  } as LoadingAction;
};
